import type { SVGProps } from 'react';

const SvgPurchaseRecovery = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="purchase-recovery">
      <path d="m5.85 28-4.24.72.26 1.48 5.85-1a.75.75 0 0 0 .61-.85l-.84-5.73L6 22.8l.55 3.79a14.19 14.19 0 0 1-.34-20.87 14.2 14.2 0 0 1 20.07.49 14.2 14.2 0 0 1-.49 20.07 14 14 0 0 1-10.14 3.91 14.3 14.3 0 0 1-3.74-.59l-.43 1.4a15.6 15.6 0 0 0 4.13.65H16a15.7 15.7 0 0 0 15.69-15.26A15.69 15.69 0 0 0 16.39.31 15.69 15.69 0 0 0 5.85 28" />
      <path d="m11.21 17.42.89 5.5a2.75 2.75 0 0 0 2.73 2.32h2.33a2.75 2.75 0 0 0 2.73-2.32l.89-5.5a2.75 2.75 0 0 0-2.72-3.2h-4.13a2.75 2.75 0 0 0-2.72 3.2M13 16.16a1.26 1.26 0 0 1 1-.44h4.13a1.25 1.25 0 0 1 1.24 1.46l-.89 5.5a1.25 1.25 0 0 1-1.25 1.06h-2.4a1.26 1.26 0 0 1-1.25-1.06l-.89-5.5a1.26 1.26 0 0 1 .31-1.02M19.91 9.22a3.85 3.85 0 1 0-3.84 3.84 3.85 3.85 0 0 0 3.84-3.84m-6.19 0a2.35 2.35 0 1 1 2.35 2.34 2.35 2.35 0 0 1-2.35-2.34" />
    </g>
  </svg>
);

export default SvgPurchaseRecovery;
